<template>
  <div
    v-if="formattedDateTimeArray.length === 2"
    class="flex"
    :class="{ 'flex-col': showTimeBelowDate }"
  >
    <div
      v-tooltipable
      class="truncate"
      :class="showTimeBelowDate ? 'text-label' : 'text-headline'"
      :data-cy="showTimeBelowDate ? 'date' : 'time'"
    >
      {{ formattedDateTimeArray[0] }}
    </div>
    <span v-if="dateTimeDivider">{{ dateTimeDivider }}</span>
    <div
      v-tooltipable
      class="truncate"
      :class="
        showTimeBelowDate
          ? 'text-headline'
          : 'ml-1 truncate whitespace-nowrap text-label'
      "
      :data-cy="showTimeBelowDate ? 'time' : 'date'"
    >
      {{ formattedDateTimeArray[1] }}
    </div>
  </div>
  <div v-else data-cy="placeholder">-</div>
</template>

<script setup lang="ts">
import { computed } from "vue";

import { formatDateCustom } from "@/helpers/formatting";

const { value, showTimeBelowDate = true } = defineProps<{
  value: string | null;
  showTimeBelowDate?: boolean;
}>();

const formattedDateTimeArray = computed(() => {
  if (!value) {
    return [];
  }

  const format = showTimeBelowDate
    ? "MMMM dd, yyyy|hh:mm a"
    : "hh:mm a|MMMM dd, yyyy";

  const formattedDateTime = formatDateCustom(value, format, true);

  return formattedDateTime.split("|");
});

const dateTimeDivider = computed(() => (showTimeBelowDate ? "" : ","));
</script>
